<template>
    <van-button style="background-color: #4BA9F6; color: white; border-radius: 10px;">{{name}}
      </van-button>
</template>
<script>
import { Button } from 'vant';

export default {
    name: "EqButton",
    components: {
        "van-button": Button,
    },
    props: {
        name: {
            type: String,
            default: "text"
        },
    },
    data() {
        return {
        };
    },
}
</script>